module.exports = __webpack_public_path__ + "static/media/background3.9a50af83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bg/background3.jpg
// module id = 408
// module chunks = 0